import React from 'react';
import SInputField from '@/components/ui/molecules/SInputField';
import { Pencil } from 'phosphor-react';

const InputTest: React.FC = () => {
  return (
    <div
      style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 16 }}
    >
      <h1 style={{ color: '#FFF' }}>SInputField Test</h1>

      <SInputField
        variant="email"
        state="default"
        showIcon
        labelText="Email (default)"
        placeholder="Enter your email"
      />

      <SInputField
        variant="email"
        state="active"
        showIcon
        labelText="Email (active)"
        placeholder="Enter your email"
      />

      <SInputField
        variant="email"
        state="default"
        labelText="Email without icon"
        placeholder="Enter your email"
      />

      <SInputField
        variant="email"
        state="default"
        showIcon
        placeholder="Field without Label"
      />

      <SInputField
        variant="email"
        state="active"
        showIcon
        icon={<Pencil size={20} />}
        labelText="Email (active)"
        placeholder="Field with custom icon"
      />

      <div className="s-input-row">
        <SInputField variant="country" state="default" />
        <SInputField
          variant="phone"
          state="default"
          showIcon
          placeholder="801-555-1234"
        />
      </div>

      <div className="s-input-row">
        <SInputField variant="country" state="active" />
        <SInputField
          variant="phone"
          state="active"
          showIcon
          placeholder="801-555-1234"
        />
      </div>

      {/* Examples demonstrating type / minLength / maxLength support */}
      <SInputField
        variant="email"
        labelText="Email with length limits"
        placeholder="Enter your email"
        maxLength={64}
      />

      <SInputField
        variant="phone"
        labelText="Phone (numeric, 7-15 chars)"
        showIcon
        maxLength={15}
        placeholder="801-555-1234"
      />
    </div>
  );
};

export default InputTest;
